import React from 'react';
import { debounce } from 'lodash';
import useTimeStore from '../ZustandProvider';

const ExportProviderMap = ({
  deleteMarkers,
  drawGeometriesNotes,
  drawGeometriesTemplates,
  drawLayerSideBySide,
  drawRouteFunction,
  drawPointsRouteFunction,
  currentLocation,
  drawToDownload,
  gotoLocation,
  mapbol,
  mapCenter,
  goToCoordinatesFunction
}) => {
  const boton1 = useTimeStore(state => state.boton1);
  const boton2 = useTimeStore(state => state.boton2);
  const coordOnMap = useTimeStore(state => state.coordOnMap);
  const coordsAnnotationTemplate = useTimeStore(state => state.coordsAnnotationTemplate);
  const drawRoute = useTimeStore(state => state.drawRoute);
  const geometryConfig = useTimeStore(state => state.geometryConfig);
  const goToCoordinates = useTimeStore(state => state.goToCoordinates);
  const isSideBySide = useTimeStore(state => state.isSideBySide);
  const layerSide = useTimeStore(state => state.layerSide);
  const showNotesOnMap = useTimeStore(state => state.showNotesOnMap);
  const setDataToSend = useTimeStore(state => state.setDataToSend);
  const setCenterMap = useTimeStore(state => state.setCenterMap);
  const setCoordOnMap = useTimeStore(state => state.setCoordOnMap);
  const setPointsRoute = useTimeStore(state => state.setPointsRoute);
  const setGoToCoordinates = useTimeStore(state => state.setGoToCoordinates);
  const setShowNotesOnMap = useTimeStore(state => state.setShowNotesOnMap);

  React.useEffect(() => {
    if (mapbol) {
      setTimeout(() => {
        gotoLocation();
      }, 120);
    }
  }, [boton1]);
  React.useEffect(() => {
    if (mapbol) {
      setTimeout(() => {
        currentLocation(false);
      }, 120);
    }
  }, [boton2]);
  React.useEffect(() => {
    if (mapbol) {
      setTimeout(() => {
        setCenterMap(mapCenter);
      }, 120);
    }
  }, [mapCenter]);

  const debounced = React.useCallback(
    debounce((coordOnMapProp, setCoordonMapProp, showNotes, setShowNotes) => {
      drawGeometriesNotes(coordOnMapProp, setCoordonMapProp, showNotes, setShowNotes);
    }),
    []
  );

  React.useEffect(() => {
    if (mapbol) debounced(coordOnMap, setCoordOnMap, showNotesOnMap, setShowNotesOnMap);
  }, [showNotesOnMap.updateMap, showNotesOnMap.methodEditor]);

  React.useEffect(() => {
    if (mapbol) {
      drawGeometriesTemplates(coordsAnnotationTemplate);
    }
  }, [coordsAnnotationTemplate]);

  React.useEffect(() => {
    if (mapbol) {
      deleteMarkers();
      if (geometryConfig === 'RouteOnMap') {
        drawPointsRouteFunction({ setPointsRoute });
      } else {
        drawToDownload({
          geometryConfig,
          setDataToSend,
          setCoordOnMap
        });
      }
    }
  }, [geometryConfig]);

  React.useEffect(() => {
    if (mapbol) {
      drawToDownload({
        geometryConfig,
        setDataToSend,
        setCoordOnMap
      });
    }
  }, [mapbol]);

  React.useEffect(() => {
    if (mapbol) {
      drawRouteFunction({ drawRoute });
    }
  }, [drawRoute]);

  React.useEffect(() => {
    if (mapbol) {
      drawLayerSideBySide();
    }
  }, [isSideBySide, layerSide]);

  React.useEffect(() => {
    if (mapbol) {
      goToCoordinatesFunction({ geometryConfig, goToCoordinates, setGoToCoordinates });
    }
  }, [goToCoordinates]);
  return false;
};

export default ExportProviderMap;
